import React from 'react';

const PrivacyModal: React.FC = () => {
  return (
    <div
      className="modal fade"
      id="privacyModal"
      tabIndex={-1}
      aria-labelledby="privacyModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content shadow-lg border-0">
          <div className="modal-header bg-body-tertiary py-3 border-body">
            <h5
              className="modal-title fw-bold text-body-emphasis"
              id="privacyModalLabel"
            >
              Privacy Policy
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Chiudi"
            />
          </div>

          <div
            className="modal-body p-4 bg-body"
            style={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            <div className="text-body">
              <p>
                La presente informativa descrive le modalità di trattamento dei
                dati personali degli utenti che visitano e utilizzano il sito.
              </p>

              <h6 className="fw-bold mt-4">1. Titolare del trattamento</h6>
              <p className="mb-2">
                Titolare del trattamento: <strong>Annalisa Picca</strong>
              </p>
              <p className="mb-2">
                Sede: <strong>Via Simone Stratico n. 18 20148 Milano</strong>
              </p>
              <p className="mb-2">
                Email di contatto: <strong>info@benessereposturale.it</strong>
              </p>
              <p className="mb-2">
                PEC: <strong>annalisapicca@pec.it</strong>
              </p>
              <p>
                P.IVA: <strong>13991250963</strong>
              </p>

              <h6 className="fw-bold mt-4">2. Tipologia di dati raccolti</h6>
              <p>
                Il sito può trattare dati identificativi e di contatto inseriti
                direttamente dall’utente in fase di registrazione o utilizzo dei
                servizi, tra cui nome, cognome, email e data di nascita.
              </p>
              <p>
                Possono inoltre essere trattati dati tecnici necessari al
                funzionamento del sito, alla sicurezza della piattaforma e alla
                corretta erogazione dei contenuti acquistati o gratuiti.
              </p>

              <h6 className="fw-bold mt-4">3. Finalità del trattamento</h6>
              <ul>
                <li>
                  consentire la registrazione e l’accesso all’area riservata;
                </li>
                <li>
                  erogare videocorsi online in streaming agli utenti
                  autorizzati;
                </li>
                <li>
                  consentire l’accesso alle risorse gratuite disponibili sul
                  sito;
                </li>
                <li>gestire gli acquisti e i relativi pagamenti;</li>
                <li>
                  inviare comunicazioni di servizio o notifiche interne agli
                  utenti registrati;
                </li>
                <li>
                  rispondere a richieste inviate spontaneamente via email o
                  WhatsApp;
                </li>
                <li>
                  adempiere a obblighi di legge, fiscali, amministrativi e di
                  sicurezza.
                </li>
              </ul>

              <h6 className="fw-bold mt-4">
                4. Base giuridica del trattamento
              </h6>
              <p>
                Il trattamento dei dati personali si fonda sull’esecuzione di
                misure precontrattuali adottate su richiesta dell’utente,
                sull’esecuzione di un contratto o di servizi richiesti
                dall’utente, sull’adempimento di obblighi legali e, ove
                necessario, sul legittimo interesse del titolare alla sicurezza,
                gestione tecnica e tutela dei propri diritti.
              </p>

              <h6 className="fw-bold mt-4">
                5. Registrazione e area riservata
              </h6>
              <p>
                L’utente può registrarsi al sito per accedere a contenuti
                gratuiti oppure a contenuti acquistati. I dati richiesti in fase
                di registrazione sono limitati a nome, cognome, email e data di
                nascita.
              </p>
              <p>
                Le credenziali di accesso sono personali e non devono essere
                condivise con terzi.
              </p>

              <h6 className="fw-bold mt-4">6. Acquisti e pagamenti</h6>
              <p>
                Il sito consente l’acquisto di videocorsi e di eventuali altri
                contenuti o servizi digitali. I pagamenti possono essere gestiti
                tramite fornitori esterni quali Stripe, PayPal e Satispay.
              </p>
              <p>
                I dati di pagamento vengono trattati direttamente dai rispettivi
                fornitori secondo le loro informative privacy e i loro termini
                di servizio. Il titolare del sito non memorizza integralmente i
                dati completi delle carte di pagamento.
              </p>

              <h6 className="fw-bold mt-4">
                7. Contenuti gratuiti e materiali scaricabili
              </h6>
              <p>
                Il sito può rendere disponibili materiali gratuiti, inclusi ad
                esempio video, audio o documenti PDF. L’eventuale accesso o
                download di tali contenuti può richiedere la registrazione
                dell’utente.
              </p>

              <h6 className="fw-bold mt-4">8. Contatti via email o WhatsApp</h6>
              <p>
                L’utente può contattare il titolare spontaneamente tramite email
                o WhatsApp per richiedere informazioni o consulenze. In tali
                casi saranno trattati i dati comunicati volontariamente
                dall’utente al solo fine di rispondere alla richiesta e gestire
                i contatti conseguenti.
              </p>

              <h6 className="fw-bold mt-4">9. Hosting e fornitori tecnici</h6>
              <p>
                Il sito è ospitato presso Hostinger e può avvalersi di fornitori
                tecnici e infrastrutturali necessari al funzionamento della
                piattaforma, alla sicurezza, alla gestione dei contenuti e dei
                pagamenti.
              </p>

              <h6 className="fw-bold mt-4">10. Modalità del trattamento</h6>
              <p>
                I dati sono trattati con strumenti elettronici e organizzativi
                adeguati a garantire sicurezza, integrità, disponibilità e
                riservatezza, nel rispetto della normativa applicabile.
              </p>

              <h6 className="fw-bold mt-4">11. Conservazione dei dati</h6>
              <p>
                I dati personali sono conservati per il tempo necessario al
                perseguimento delle finalità per cui sono stati raccolti e,
                successivamente, nei limiti previsti dagli obblighi di legge o
                per la tutela dei diritti del titolare.
              </p>
              <p>
                I dati relativi agli account registrati possono essere
                conservati fino alla richiesta di cancellazione dell’utente o
                alla chiusura dell’account, salvo obblighi ulteriori di
                conservazione.
              </p>

              <h6 className="fw-bold mt-4">12. Comunicazione dei dati</h6>
              <p>
                I dati potranno essere comunicati a soggetti che agiscono come
                fornitori di servizi strettamente connessi alla gestione del
                sito e dei servizi offerti, inclusi hosting provider,
                piattaforme di pagamento, consulenti tecnici, amministrativi o
                fiscali, nei limiti strettamente necessari.
              </p>

              <h6 className="fw-bold mt-4">13. Trasferimento dei dati</h6>
              <p>
                Alcuni fornitori terzi utilizzati dal sito potrebbero trattare
                dati anche al di fuori dello Spazio Economico Europeo. In tali
                casi il trattamento avviene nel rispetto delle garanzie previste
                dalla normativa applicabile.
              </p>

              <h6 className="fw-bold mt-4">14. Diritti dell’interessato</h6>
              <p>
                L’utente può esercitare i diritti previsti dagli articoli 15 e
                seguenti del GDPR, tra cui il diritto di accesso, rettifica,
                cancellazione, limitazione del trattamento, opposizione e
                portabilità dei dati, nei casi previsti dalla legge.
              </p>
              <p>
                L’utente ha inoltre il diritto di proporre reclamo all’Autorità
                Garante per la protezione dei dati personali, qualora ritenga
                che il trattamento avvenga in violazione della normativa
                vigente.
              </p>

              <h6 className="fw-bold mt-4">15. Cookie</h6>
              <p>
                Il sito utilizza esclusivamente cookie tecnici e strumenti
                strettamente necessari al funzionamento della piattaforma, alla
                navigazione, all’autenticazione e alla corretta fruizione dei
                contenuti e dei servizi richiesti dall’utente.
              </p>

              <h6 className="fw-bold mt-4">16. Modifiche all’informativa</h6>
              <p className="mb-0">
                Il titolare si riserva il diritto di aggiornare o modificare la
                presente informativa in qualsiasi momento. Le eventuali
                modifiche saranno rese disponibili tramite il sito.
              </p>
            </div>

            <div className="modal-footer bg-body-tertiary py-3 border-body mt-4">
              <button
                type="button"
                className="btn btn-primary px-4"
                data-bs-dismiss="modal"
              >
                Chiudi
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModal;
